import { render, staticRenderFns } from "./UserDiagnosticsItem.vue?vue&type=template&id=696b88aa"
import script from "./UserDiagnosticsItem.vue?vue&type=script&lang=js"
export * from "./UserDiagnosticsItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports